module.exports = __webpack_public_path__ + "static/media/p_28_0.806ada42.png";